import { CentralLoadingIndicator, PetAvatars } from "../../../../components";

import DoctorVisitToggleCard from "./DoctorVisitToggleCard";
import React from "react";
import { UrgentReasonCard } from "./UrgentReasonCard";
import { useUrgentVisitReasons } from "../../../../hooks/urgent-visit/useUrgentVisitReasons";
import { useUrgentVisitStore } from "../../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";

interface ReasonSelectionStepProps {
  onRequestDoctorVisit?: () => void;
}

export const ReasonSelectionStep = ({ onRequestDoctorVisit }: ReasonSelectionStepProps) => {
  const { selectedPets, currentPetIndex } = useUrgentVisitStore();
  const { reasons, loading, selectedReasons, toggleReason } = useUrgentVisitReasons();

  const currentPet = selectedPets[currentPetIndex];

  const handleDoctorVisitToggle = () => {
    if (onRequestDoctorVisit) {
      onRequestDoctorVisit();
    }
  };

  if (!currentPet) return null;

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full flex flex-col gap-4 border border-taupe-50 rounded-xl p-4">
        <div className="flex justify-between items-center gap-2">
          <div>
            <p className="grenette-pro font-semibold text-lg leading-5 text-light-black">
              {`Which of these does ${currentPet.name} need?`}
            </p>
            <p className="text-sm text-gray-1 mt-1">
              {"Select all that apply."}
            </p>
          </div>
          <PetAvatars
            height={48}
            width={48}
            petDetails={[currentPet]}
          />
        </div>

        {loading ? (
          <CentralLoadingIndicator />
        ) : (
          <div className="w-full grid grid-cols-2 gap-2">
            {reasons.map((reason) => (
              <UrgentReasonCard
                key={reason.value}
                title={reason.label}
                value={reason.value}
                isSelected={selectedReasons.includes(reason.value)}
                onSelect={toggleReason}
              />
            ))}
          </div>
        )}
      </div>
      <DoctorVisitToggleCard handleToggle={handleDoctorVisitToggle} />
    </div>
  );
};
